import React, { Component } from 'react'
import PropTypes from 'prop-types'

class CardTitle extends Component {
  render () {
    return (
      <div className='card-name col-12 mt-0 p-0'>
        <h2 className='txt-body-sm color-ui-2 txt-font-body txt-left' aria-label={this.props.altText}>
          {this.props.title}
        </h2>
      </div>
    )
  }
}

CardTitle.propTypes = {
  title: PropTypes.string.isRequired,
  altText: PropTypes.string
}

export default CardTitle



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductCard/CardTitle/index.js